module.exports = __webpack_public_path__ + "05355214a3b42c3e2eb0e1d4e8f4dab4.jpg";